/* eslint-disable */
import { useDispatch } from 'react-redux'
import { updateView } from '../../redux/slices/meta'
import { ViewTypes } from '../../types/state'
import {
	CloseButtonWrapper,
	CloseButton,
	// Paragraph,
	// Heading,
	TNCWrapper,
	// Heading2,
	// OL,
	// Table,
	// TH,
	// TD,
} from './style'
const TnContent = () => {
	const dispatch = useDispatch()

	const closeWindowPortal = () => {
		dispatch(updateView(ViewTypes.VOTES))
	}

	return (
		<>
			<TNCWrapper>
				<div>
					<p>
						<strong>TERMS AND CONDITIONS GOVERNING PARTICIPATION</strong>
					</p>
					<p>
						<strong>IN LENSKART GOLDEN WEEK 2023</strong>
					</p>
					<ol>
						<li>
							<strong>CONTEST DESCRIPTION:</strong>
						</li>
					</ol>
					<p>
						"<em>Lenskart Golden Week</em>" is a skill based online quiz
						contest of the show "Kon Honaar Crorepati" which is
						conceptualized, organized, produced and broadcasted by Culver
						Max Entertainment Private Limited ("<strong>Producer</strong>
						") for initial exhibition on the channel Sony Marathi ("
						<strong>Channel</strong>"). The contest will be hosted and can
						be played on the Lenskart app which is owned and controlled by
						Lenskart Solutions Private Limited.
					</p>
					<ol>
						<li>
							<strong>DEFINITIONS:</strong>
						</li>
					</ol>
					<p>
						For the purposes of the Rules &amp; Regulations, the
						expressions used as shown herein-under shall have the meaning
						ascribed to them as shown herein-below:
					</p>
					<ol>
						<ol>
							<li>
								"Producer" or "CMEPL" or "Organizer" means Culver Max
								Entertainment Private Limited
							</li>
							<li>
								"Company" means "Lenskart Solutions Private Limited" or
								"LSPL" owning and operating Lenskart app;
							</li>
							<li>
								"Contest" means the general knowledge based online quiz
								contest organized by the Producer during the Show, which
								will be played on the Lenskart App by the Participant in
								accordance with the Rules &amp; Regulations during the
								period mentioned in point D (1) (a) below, as an
								eligibility criteria to participate in the "Lenskart
								Golden Week",
							</li>
							<li>
								"Lenskart Golden Week/Golden Week" means the week (i.e.
								05
								<sup>th</sup>
								June 2023 to 11 <sup>th</sup> June 2023) or any other
								dates mutually agreed between Lenskart and Producer,
								during which the Contest Winners, being the users of
								Lenskart, will be exclusively eligible to participate in
								the Show.
							</li>
							<li>
								"Lenskart App" or "App" means the platform accessible as
								an application and through mobile, owned and operated by
								Lenskart Solutions Private Limited where the Contest
								will be hosted;
							</li>
							<li>
								"Participant(s)/You" means any person(s) who registers
								and / or participates in the Contest on the App and who
								(i) is above eighteen (18) years of age as on June 05,
								2023; (ii) is a citizen of India residing in India (iii)
								is of sound mind and health (iv) and agrees to enter
								into and participate in the Contest in accordance with
								the Terms and conditions as defined in this document.
							</li>
							<li>
								"Rules &amp; Regulations" means these terms and
								conditions framed governing the Contest, as stated
								herein in entirety and as may be amended by the Producer
								and LSPL from time to time.
							</li>
							<li>
								"Show" means the television series titled "
								<strong>
									<em>Kon Honaar Crorepati – Season 04</em>
								</strong>
								" produced by CMEPL and telecasted on its channel Sony
								Marathi.
							</li>
							<li>
								"Stipulated Time" for the purposes of the Contest shall
								mean the period until which the Company permits a
								Participant to answer any question forming part of the
								Contest; The Stipulated Time of a particular question is
								from 21:00:00 PM of the day on which such question is
								displayed on the App to 20:59:59 PM of the immediately
								following day.
							</li>
							<li>
								"Contest Winner(s)/Winner(s)" shall mean such eligible
								Auditionees (as defined below) who get selected for the
								Fastest Finger First as may be determined by the
								Producer in terms of the Rules &amp; Regulations.
							</li>
						</ol>
					</ol>
					<ol>
						<li>
							<strong>ELIGIBILITY CRITERIA</strong>
						</li>
					</ol>
					<p>
						In order to participate in the Contest, all the following
						conditions need to be fulfilled:
					</p>
					<ul>
						<li>
							individuals should have registered and / or participated in
							the Contest via the Lenskart App only; and
						</li>
						<li>
							individuals should be above eighteen (18) years of age as
							on June 05, 2023;
						</li>
						<li>
							individual should be a citizen of India residing in India;
						</li>
						<li>individual should be of sound mind and health; and</li>
						<li>
							such individual agrees to enter into and participate in the
							Contest in accordance with the terms and conditions as
							defined in this document.
						</li>
					</ul>
					<p>
						<strong /> <br />
					</p>
					<p>
						<strong>D. PROCEDURE TO PARTICIPATE IN THE CONTEST:</strong>
					</p>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							<strong /> <strong>Participation</strong>
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<ol>
							<li>
								Eligible Participants can participate in the Contest by
								registering on the Lenskart App. The Contest will be
								available for registration on the Lenskart App as per
								the following schedule:
							</li>
						</ol>
					</ol>
					<table cellSpacing={0} cellPadding={0}>
						<tbody>
							<tr>
								<td rowSpan={2} valign="middle">
									<p>
										<strong>Question</strong>
									</p>
								</td>
								<td colSpan={2} valign="middle">
									<p>
										<strong>Lines open</strong>
									</p>
								</td>
								<td colSpan={2} valign="middle">
									<p>
										<strong>Lines close</strong>
									</p>
								</td>
							</tr>
							<tr>
								<td valign="middle">
									<p>
										<strong>Date</strong>
									</p>
								</td>
								<td valign="middle">
									<p>
										<strong>Time</strong>
									</p>
								</td>
								<td valign="middle">
									<p>
										<strong>Date</strong>
									</p>
								</td>
								<td valign="middle">
									<p>
										<strong>Time</strong>
									</p>
								</td>
							</tr>
							<tr>
								<td valign="middle">
									<p>1</p>
								</td>
								<td valign="middle">
									<p>05 June 2023</p>
								</td>
								<td valign="middle">
									<p>21:00:00</p>
								</td>
								<td valign="middle">
									<p>06 June 2023</p>
								</td>
								<td valign="middle">
									<p>20:59:59</p>
								</td>
							</tr>
							<tr>
								<td valign="middle">
									<p>2</p>
								</td>
								<td valign="middle">
									<p>06 June 2023</p>
								</td>
								<td valign="middle">
									<p>21:00:00</p>
								</td>
								<td valign="middle">
									<p>07 June 2023</p>
								</td>
								<td valign="middle">
									<p>20:59:59</p>
								</td>
							</tr>
							<tr>
								<td valign="middle">
									<p>3</p>
								</td>
								<td valign="middle">
									<p>07 June 2023</p>
								</td>
								<td valign="middle">
									<p>21:00:00</p>
								</td>
								<td valign="middle">
									<p>08 June 2023</p>
								</td>
								<td valign="middle">
									<p>20:59:59</p>
								</td>
							</tr>
							<tr>
								<td valign="middle">
									<p>4</p>
								</td>
								<td valign="middle">
									<p>08 June 2023</p>
								</td>
								<td valign="middle">
									<p>21:00:00</p>
								</td>
								<td valign="middle">
									<p>09 June 2023</p>
								</td>
								<td valign="middle">
									<p>20:59:59</p>
								</td>
							</tr>
							<tr>
								<td valign="middle">
									<p>5</p>
								</td>
								<td valign="middle">
									<p>09 June 2023</p>
								</td>
								<td valign="middle">
									<p>21:00:00</p>
								</td>
								<td valign="middle">
									<p>10 June 2023</p>
								</td>
								<td valign="middle">
									<p>20:59:59</p>
								</td>
							</tr>
							<tr>
								<td valign="middle">
									<p>6</p>
								</td>
								<td valign="middle">
									<p>10 June 2023</p>
								</td>
								<td valign="middle">
									<p>21:00:00</p>
								</td>
								<td valign="middle">
									<p>11 June 2023</p>
								</td>
								<td valign="middle">
									<p>20:59:59</p>
								</td>
							</tr>
						</tbody>
					</table>
					<ol>
						<ol>
							<li>
								The above-mentioned schedule could be added to,
								modified, or cancelled based on programming/ technical
								requirements of Producer and/or LSPL or in the event the
								Show is for any reason rescheduled, extended, cancelled
								or terminated early, by the Producer after consultation
								with LSPL.
							</li>
							<li>
								The mobile number from which the registration is
								received will be used to identify the Participant as a
								unique identification number. We urge Participants to
								use numbers where they would be clearly identified as
								the Participant of the Contest.
							</li>
							<li>
								Any entry for participation in the Contest is not
								transferrable.
							</li>
							<li>
								The Participant may be required to furnish to the
								Producer any necessary supporting documentation as proof
								of age, address, name, photo identity and nationality
								i.e., one original and attested photocopies of either
								(i) passport/driving license or (ii) PAN Card along with
								birth certificate and ration card or (iii) voter
								identity card with birth certificate (iv) UID/Aadhar
								Card if they are selected for the audition process of
								the Golden Week.
							</li>
							<li>
								The failure to provide proof or affidavit of
								eligibility, including the proof of name, address and
								correct date of birth within the time as stipulated in
								the Rules &amp; Regulations or upon request by the
								Producer may result in disqualification. Producer also
								reserves the right to disqualify a Contest Winner in
								case where a discrepancy is found to exist in the
								information furnished/provided/stated by the Contest
								Winner during the conversation with the Producer or any
								of the Producer's sub-contractors and vendors in the
								Contest, and/or in the information stated in the
								documents furnished by the Contest Win ner or at any
								time.
							</li>
							<li>
								Producer may, at its discretion, contact the
								Participant(s), if required, for any clarifications
								needed for the information provided.
							</li>
							<li>
								All personal details and information requested by and
								supplied to LSPL and/or Producer by each Participant
								must be truthful, accurate and in no way misleading.
								LSPL and/or the Producer reserves the right to
								disqualify any Participant(s) from the Contest and/or
								the Golden Week at its sole discretion, should the
								Participant(s) at any stage supply untruthful,
								inaccurate or misleading personal details and/or
								information.
							</li>
						</ol>
					</ol>
					<ol>
						<li>
							<strong /> <strong>Steps for Registration</strong>
						</li>
					</ol>
					<p>
						<strong />
					</p>
					<ol>
						<li>
							Download the Lenkart App from the application store. Please
							note, the application download is free of cost, however
							data charges may apply. For further details regarding App
							please contact your telecom operator. Please note, the
							Contest is not accessible via browsers on your PC or
							laptopsa or any other device.
						</li>
						<li>
							If You are a first time user, then You will be prompted to
							register by providing your mobile number. An OTP will be
							sent across to your mobile number to verify the same.
						</li>
						<li>
							Click on "Lenskart Golden Week" banner/ Access "Lenskart
							Golden Week" from the menu.
						</li>
						<li>Select Language Preference (English/Hindi).</li>
						<li>
							Read and click on the Terms &amp; Conditions checkbox.
						</li>
						<li>Click on the "Play Now" tab.</li>
						<li>
							Once You submit your answer to the Contest question of the
							week, You may be prompted to provide us your basic details
							like name, age, gender, occupation, mobile number and city.
						</li>
						<li>
							In the event, it is not possible to determine with
							certainty the person who registered from a particular
							mobile number, that entry would be disqualified.
							Participants(s) are requested to use mobile numbers which
							are unique to them.
						</li>
						<li>
							The procedures for registration and participation in the
							Contest are subject to the Rules &amp; Regulations stated
							herein. Non-conformance by any Participant(s) to the Rules
							&amp; Regulations will disqualify him/her from
							participation or winnings, immediately, as the case may be.
						</li>
						<li>
							Taking part in the registration process shall be deemed to
							be acceptance by the Participant(s) to receive promotional
							messages from LSPL or any third party so authorized by
							LSPL. In the event the Participant wants to opt out from
							receiving any such promotional messages then the
							Participant can write to LSPL.
						</li>
					</ol>
					<ol>
						<li>
							<strong />
							<strong>Charges for participation in the Contest</strong>
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							a)The Lenskart application download and participation in
							the Contest are free of cost, however data charges may
							apply. For further details regarding the App please contact
							your telecom operator.
						</li>
						<li>
							b)Please check with your telecom operator for any other
							applicable charges. In case any user registers while
							roaming in a different circle/zone/country, additional
							roaming rates may apply. Please contact your telecom
							operator for the applicable rates.
						</li>
						<li>
							There is no levy of an entry fee for participation in the
							Contest. Any person who claims to be from LSPL or CMEPL and
							asks the Participant for paying an entry fee for
							participation in the Golden Week or the Show or states that
							LSPL or CMEPL is distributing any lotteries or cash prizes,
							is defrauding the Participant(s) and he/she should report
							this to the local police immediately. There are also no
							lotteries, prize monies, cash prizes etc. distributed by
							LSPL or CMEPL. The only way to participate in the Contest
							and to win is in the manner detailed herein.
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							<strong /> <strong>Playing Rules</strong>
						</li>
					</ol>
					<ol>
						<li>
							From June 05, 2023 to June 11 2023, the Participant will
							have to answer the question as displayed on the App within
							the Stipulated Time.
						</li>
						<li>
							The Stipulated Time of a particular question is from
							21:00:00 PM of the day on which such question is displayed
							on the App to 20:59:59 PM of the immediately following day.
							Once the "Submit" button has been pressed, the Participant
							will not be allowed to change the answer. Please note that
							the Participant has to select the answer option and press
							the "Submit" button within the Stipulated Time.
						</li>
						<li>
							Post submission of the answer, the Participant(s) will not
							be permitted to modify / alter / change the answer
							submitted.
						</li>
						<li>
							Only the answers submitted and received within the
							Stipulated Time will be considered valid.
						</li>
						<li>
							LSPL and/or the Producer will not entertain any claims /
							questions / queries with respect to the authenticity or
							correctness of any questions and answers for the questions
							asked in any round of the Contest. The Producer's decision
							on the correctness or incorrectness of any answer is final
							and binding on all Participants.
						</li>
					</ol>
					<ol>
						<li>
							<strong /> <strong>Contest Winner Selection</strong>
						</li>
					</ol>
					<ol>
						<li>
							Any Participant who has (i) attempted and answered at least
							one question correctly; and (ii) has successfully filled
							the profile related questions asked during the Registration
							process during June 05 and June 11, 2023; and (iii)
							participates in the Contest in accordance with the Terms
							and conditions is eligible to be shortlisted for the
							Contest Winner Selection. The winner selection and the
							eligibility thereof are specified in the below table.
						</li>
						<li>
							All Participants who have filled the form and the profile
							questions updated in the Contest registration section
							within the defined timelines (June 05, 2023 to June 11,
							2023) are eligible to be shortlisted for the following
							prize subject to Clause 5 (a) above and answer the question
							of the day correctly:
						</li>
					</ol>
					<table cellSpacing={0} cellPadding={0}>
						<tbody>
							<tr>
								<td valign="top">
									<p>S No.</p>
								</td>
								<td valign="top">
									<p>Prize Description</p>
								</td>
								<td valign="top">
									<p>Number of winners for the Show</p>
								</td>
								<td valign="top">
									<p>Eligible Participants</p>
								</td>
							</tr>
							<tr>
								<td valign="top">
									<p>1</p>
								</td>
								<td valign="top">
									<p>
										Opportunity to be on the hot seat with Sachin
										Khedekar
									</p>
								</td>
								<td valign="top">
									<p>
										Total 10 Winners will get the opportunity to be
										part of the Show as Fastest Finger First
										contestants during the Golden Week. The Golden
										Week will contain a total of four episodes.
									</p>
								</td>
								<td valign="top">
									<p>
										Participants who complete the registration form
										and answer the question of the day correctly (as
										mentioned above in Clause 5 (a)) on the Lenskart
										app during the period (June 05, 2023, to June 11,
										2023)
									</p>
								</td>
							</tr>
						</tbody>
					</table>
					<p>
						* Note: The above prizes and conditions may be added to,
						modified, or cancelled based on CMEPL's discretion.
					</p>
					<ol>
						<li>
							The Eligible Participants will be shortlisted on a
							pre-defined reservation criteria as defined by CMEPL, and
							approximately 150 shortlisted Eligible Participants will be
							selected to attend the online auditions as Auditionees for
							the Lenskart Golden Week.
						</li>
					</ol>
					<p>
						Note: The above shortlisting criteria for the Lenskart Golden
						Week may be modified based on the Producer's discretion as
						they deem fit.
					</p>
					<ol>
						<li>
							Once a mobile number is chosen and confirmed for audition,
							it would not be chosen for the second time. CMEPL reserves
							the right to alter/reduce/increase the number of Eligible
							Participants (and the selection criteria thereafter) that
							will be selected to attend the audition as Auditionees, at
							its sole discretion.
						</li>
					</ol>
					<ol>
						<li>
							The audition, evaluation and shortlisting of Eligible
							Participants as Hot Seat Contestants have been detailed in
							Annexure 1. The details of the winner selection will be
							intimated to such Winner(s) by CMEPL on the mobile number
							provided by such Participant(s) at the time of registration
							for the Contest.
						</li>
					</ol>
					<ol>
						<li>
							CMEPL reserves the rights to determine and/or announce the
							timelines and the methodology of determining Contest
							Winners from time to time.
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							<strong /> <strong>Systems and Availability</strong>
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<ol>
							<li>
								LSPL and/or CMEPL will not be responsible for any break
								or disconnection or disruption in network connectivity
								in any manner, irrespective of the network being used.
								Network issues can disrupt various aspects of the
								Contest such as receipt of questions and answer options,
								receipt of any sound, text, image or audio files related
								to the question, receipt of answer chosen by the
								Participant, etc. The Participant is advised to remain
								in an area with a strong and stable/ continuous mobile
								network signal of the telecom operator or internet
								service provider to ensure smooth functioning of the
								Contest.
							</li>
							<li>
								Any loss or outrage or dissatisfaction suffered by the
								course of participating in the Golden Week or Contest by
								a Participant would not be the responsibility of LSPL
								and/or CMEPL and/or its associates/ affiliates and LSPL
								and/or CMEPL or its associates/affiliates will not be
								responsible to make good any such loss or
								dissatisfaction.
							</li>
							<li>
								All attempts will be made to protect the data from loss
								and corruption, but in the event such data loss happens,
								CMEPL and/or LSPL may have to continue with whatever
								data is available, or in any other manner as it may deem
								reasonable. LSPL and the Producer should not be held
								responsible for any loss of data or the action taken on
								account of the same. LSPL and/or the Producer will not
								be held responsible to make good any such loss or
								dissatisfaction on account of such loss.
							</li>
							<li>
								In the event the response of the Participant is not for
								any reason received within the Stipulated Time period
								for the question, such Participant's response would not
								be considered valid even if such question(s) was/were
								correctly answered by the Participant. The Participant
								can however continue to answer questions once
								re-connected to the central game server(s). LSPL and/or
								the Producer or its vendors and partners are not
								responsible for any such instances.
							</li>
							<li>
								For sake of clarity, Participants are advised to
								participate in the Contest through one device only. In
								case multiple entries are received from a Participant
								for the same question, Producer has the right to choose
								the first answer entry received from that Participant.
								If multiple entries are received at the same time, then
								Producer will choose any of the answer entries received.
							</li>
							<li>
								The server used to communicate with the Participant has
								adequate redundancies built into it. However, in the
								rare cases, the server is down during the Contest
								period, LSPL and the Producer will, at its discretion
								but not as an obligation, determine such measures as it
								may deem fit, including cancelling certain sections or
								segments or question(s) from being scored or any other
								means at the discretion of LSPL and the Producer.
							</li>
							<li>
								The Participant acknowledges that all possible issues
								may not have been identified by LSPL and/or its partners
								and agrees to hold harmless LSPL and/or its partners for
								the application, network, process, technical or any
								other failures. Any losses, injury, discomfort, loss of
								privacy, inability to participate or any other
								discomfort of any sort caused to the Participant or the
								Participant's property or device shall not be the
								responsibility of LSPL or its partners.
							</li>
							<li>
								No person (i.e., either the Participant, or any person
								on behalf of the Participant) shall initiate litigation
								against Producer and/or Lenskart Solutions Private
								Limited, LSPL or its partners in any manner. In case of
								any complaint regarding the Contest, for any App related
								issues the complaint will be lodged at and for any other
								issues relating to the Contest, the complaint will be
								lodged at
								<a href="mailto:kbcmarathi@setindia.com">
									kbcmarathi@setindia.com
								</a>
								and with LSPL.
							</li>
							<li>
								In case any unauthorized activity is observed during the
								Contest, that particular Participant will be
								disqualified to participate till such time as LSPL and
								Producer deems fit. LSPL and/or Producer would not be
								responsible in any manner whatsoever on account of such
								disqualification.
							</li>
							<li>
								LSPL shall not be liable for any failure of the
								application server or system in the course of playing
								the Contest.
							</li>
							<li>
								LSPL shall endeavor to make all reasonably practicable
								arrangements, it cannot guarantee or assure seamless
								connectivity or continuous availability of the
								application, server, system or software to the
								Participants during the conduct of the Contest as these
								are dependent on external utilities/ service providers
								and factors which could be beyond control of LSPL.
							</li>
							<li>
								LSPL and its sub-contractors are not responsible for
								delayed receipt or non-receipt or incomplete receipt or
								corrupt receipt of answers.
							</li>
							<li>
								LSPL and/or the Producer accepts no liability and shall
								not be responsible and/or liable in any manner
								whatsoever in case the Participant(s) are unable to
								participate in the Contest due to failure on the part of
								the telecom operator, facility provider, etc., or due to
								capacity constraints or any limitations at the
								Producer's end.
							</li>
							<li>
								It shall not be open for the Participant(s) or any of
								their representatives to require an audit or
								verification of the randomizer/ selection software or
								any other criteria, process or system adopted by the
								Producer as part of the process of conduct of the
								Contest or selection of Winners resulting therefrom. No
								enquiries, appeals, verbal or written, shall be
								entertained in this regard. LSPL shall not be held
								responsible for the Winner selection process.
							</li>
						</ol>
					</ol>
					<ol>
						<li>
							<strong />
							<strong>Confidentiality and Personal Information</strong>
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							LSPL or Producer as the case may be (i.e. party collecting
							the Personal Information) shall keep all the Personal
							Information collected from the Participant(s) (including
							any sensitive personal data collected) confidential and
							shall use the same in accordance with the terms and
							conditions provided on their respective platforms. Each
							Participant, by electing to participating in the Contest
							and/or Golden Week, hereby explicitly consents to the
							collection, storage and processing of such Personal
							Information collected from him/her.. The term "Personal
							Information" shall mean and include the name and contact
							information (name, gender, age, occupation, home address,
							telephone and fax numbers and email address), valid
							identity proof such as passport number, driver's license
							number, permanent account numbers or other details
							including sensitive personal information (if any)
							pertaining to the identity of the Participant(s).
						</li>
						<li>
							The Participant(s) hereby explicitly consents to the
							collection, storage, use, disclosure, transfer or
							processing of Personal Information which may be collected
							by LSPL or Producer. The Participant(s) hereby agree and
							acknowledge that the collection, storage, use, disclosure,
							transfer or processing of the Personal Information by LSPL
							or Producer is for a lawful purpose. The Participant's by
							providing the aforesaid Personal Information hereby agree
							that LSPL shall have the right to share the Personal
							Information so collected with such other third party
							including the Producer and as required for the purpose of
							the Golden Week/ Contest and the Participant(s) hereby
							agreed that they shall not file any claim against LSPL
							and/or the Producer for sharing for such Personal
							Information. Please refer to LSPL's Privacy Policy at
							<a href="https://www.lenskart.com/privacy-policy">
								https://www.lenskart.com/privacy-policy
							</a>
							and Producer's Privacy Policy at
							<a href="https://www.sonypicturesnetworks.com/term-condition/75/privacy-policy">
								https://www.sonypicturesnetworks.com/term-condition/75/privacy-policy
							</a>
							that governs the Personal Information that may be directly
							shared by Participant with LSPL and Producer respectively.
							Participant(s) choosing to participate in the Golden Week
							agree and acknowledge these Privacy Policy and Terms of Use
							as put up on the website in addition to the conditions set
							out in these Terms and conditions which shall govern the
							Golden Week or Contest.
						</li>
						<li>
							LSPL or Producer shall deal with any Personal Information
							that it receives from Participant(s) or otherwise collects,
							holds, uses and processes in the following manner: a) LSPL
							or Producer may also disclose Personal Information, if any,
							to governmental agencies and regulators (e.g., tax
							authorities), social organizations (e.g., the social
							security administration), human resources benefits
							providers (e.g., health insurers), external advisors (e.g.,
							lawyers, accountants, and auditors), courts and other
							tribunals, and government authorities, to the extent
							required or permitted by applicable legal obligations. b)
							The level of data protection using technical, managerial,
							operational and physical security control measures by LSPL
							or Producer shall be such as to be in compliance with all
							applicable laws.
						</li>
						<li>
							In exercise of the powers conferred by applicable laws,
							LSPL or Producer shall treat the Personal Information as
							confidential and such information has to be now dealt with
							as per the provisions specified in the applicable laws.
						</li>
						<li>
							The protection of personal information entered by consumer
							on LSP mobile application will be sole responsibility of
							Lenskart platform
						</li>
					</ol>
					<ol>
						<li>
							<strong />
							<strong>Intellectual Property Rights and Publicity</strong>
						</li>
					</ol>
					<ol>
						<li>
							The Participant(s) hereby agree and consent to the
							collection, recording, processing and storing any images,
							videos, name of the Participant(s) or any other attributes
							submitted to LSPL and Producer or recorded by LSPL and/or
							Producer during the Golden Week/Contest or registration
							procedure shall on submission / creation become the
							property of LSPL and the Producer ("
							<strong>Materials</strong>") and shall be available to LSPL
							and the Producer for exploitation throughout the world in
							perpetuity. The Participant(s) hereby waives off all the
							rights that they may have with respect to such Materials.
							The Participant(s) shall ensure that the photos or videos
							submitted by them in any public domain shall not be
							obscene, vulgar, defaming, denigrating women or children,
							hurting religious sentiments, depicting violence or shall
							not infringe the rights of a third person. In the event of
							any violation to the aforementioned, the Participant(s)
							shall immediately be disqualified from taking part in the
							Golden Week or Contest or any further rounds of
							participation and such Participant(s) shall solely remain
							liable for any action (criminal/civil) arising therefrom.
						</li>
					</ol>
					<ol>
						<li>
							All the Intellectual Property Rights of the Participant(s)
							in respect of the Materials including but not limited to
							the copyright, rights of publicity, moral rights and any
							related rights shall vest with LSPL and the Producer or
							shall stand waived (as maybe applicable), and
							Participant(s) agree not to claim or enforce any of the
							aforementioned rights in any court, tribunal or any other
							forum whether in India or anywhere else. Participant(s)
							also consent to LSPL's and/or the Producer's right to
							reproduce his/her picture provided by the Participant(s) or
							portray the Participant(s) in any and all media now
							existing or hereinafter created, including without
							limitation television, film, radio and print media, without
							any compensation whatsoever for advertising and publicity
							purposes of the Golden Week or Contest or the Show, except
							where prohibited by law. The Participant(s) also consent to
							LSPL's and/or the Producer's right to use Participant(s)
							name, voice or picture, without any further permission or
							compensation for such use in any and all media now known or
							in commercial use or developed based on media now known or
							in commercial use. The Participant(s) grants LSPL and the
							Producer irrevocable consent in perpetuity to the use of
							the sound recordings, photographs, video tape, and
							illustrations taken during or in connection with the Golden
							Week or Contest, in any and all applications including but
							not limited to advertising, commercials, promotion,
							stories, text, articles, illustrations, copy and commercial
							exploitation, in any and all media forms, including but not
							limited to radio, broadcast and television, newspapers and
							magazines at any time without the Participant(s) further
							knowledge or consent. The Participant(s) hereby further
							consents to LSPL and the Producer using any photos, videos,
							handles, profiles or attributes of the Participant(s) as
							uploaded by the Participant(s) on the App or on any social
							media platform that the Participant(s) has used to register
							on the App. The Participant(s) duly understand that LSPL
							and/or the Producer may grant any third party including the
							Producer the aforesaid rights consented by the
							Participant(s) for the purpose of the Golden Week/the
							Contest/the Show as may be required.
						</li>
					</ol>
					<ol>
						<li>
							Acceptance of these Terms and conditions by the Participant
							(s) constitutes permission for the LSPL and/or the Producer
							and its affiliates to click photographs, record videos of
							the Participant(s) and use or authorize any third party to
							use the Participant(s) name, photographs, likeness, voice
							and comments for advertising and promotional purposes in
							any media worldwide for purposes of advertising and trade
							without any additional compensation whatsoever.
						</li>
					</ol>
					<ol>
						<li>
							None of the Participant(s) shall, without the prior written
							approval of LSPL or CMEPL, speak to the press or any other
							media or any third person, nor give any interviews or
							comments relating to any aspect of the Golden Week/Contest.
							The Participant shall not disclose any information
							whatsoever relating to LSPL or CMEPL to any other party.
							Violation of this clause shall immediately disqualify the
							Participant's prospects of further participation.
						</li>
					</ol>
					<ol>
						<li>
							The Winner(s) of the Contest as announced by the Producer
							from time to time, agrees that he/she shall make
							himself/herself available from time to time and co-operate
							with LSPL and/or the Producer and participate in any
							activity and/or campaign of any nature whatsoever ("
							<strong>Promotional Activity</strong>") without any
							additional money payable to the Winner(s). Further, the
							Winner(s)/Participant(s) shall at no point of time refuse
							or disagree to participate in any such Promotional Activity
							for any reason whatsoever if required by LSPL and/or the
							Producer. The Winner(s)/Participant(s) agrees that the
							footage of any nature shall vest with LSPL and the
							Producer, including but not limited to all intellectual
							property rights and any other rights for worldwide and in
							perpetuity.
						</li>
					</ol>
					<ol>
						<li>
							Acceptance of these Terms and conditions by the Participant
							constitutes permission for LSPL and/or Producer, including
							its affiliates, to click photographs, record videos of the
							Participant(s) and use the Participant(s) name,
							photographs, likeness, voice and comments for advertising
							and promotional purposes in any media worldwide for
							purposes of advertising and trade without any additional
							compensation whatsoever.
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							<strong />{' '}
							<strong>Liabilities and other disclaimers</strong>
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							LSPL and/or CMEPL is in no manner whatsoever responsible
							and/or shall not be held liable in any manner whatsoever,
							for any physical injury, death, mental trauma caused to any
							Participant(s) and/or the Winner (s) in any manner
							whatsoever, in relation to Golden Week and/or Contest
							and/or the Show and/or prizes.
						</li>
					</ol>
					<ol>
						<li>
							LSPL, CMEPL, the host, the advertising agencies, the
							sub-contractors used by LSPL or CMEPL for the Golden Week
							or the Contest or the Show, or their affiliates, and any
							person or entity connected with the production (including
							the format owners and the broadcasters of the Show) (the "
							<strong>Relevant Parties</strong>") shall be under no
							liability whatsoever to the Participant(s) and/or the
							Winner(s), in respect of any loss, damage suffered by the
							Participant(s) and/or the Winner(s) arising from or
							pursuant to the Golden Week or Contest or for any and all
							loss, damage, cost, expense or injury to life or property
							sustained by the Participant(s) and/or the Winner(s) at any
							stage of the Golden Week or the Contest or the Show whether
							or not caused by (1) the administration (including
							scheduling) of the Golden Week or the Contest or the Show;
							(2) the Participant's or any third party's participation in
							the Golden Week or Contest, or being selected or
							disqualified; (3) as a result of the decisions of LSPL or
							CMEPL; (4) as a result of any comment, remark, judgment,
							view, criticism, critique, opinion and/or observation made
							and/or passed by the host and/or LSPL and/or CMEPL; and/or
							(5) any printing, typographical or technological errors in
							any materials associated with the Golden Week or Contest.
							Notwithstanding the generality of the foregoing, the
							Relevant Parties expressly exclude liability for all
							direct, indirect and consequential loss or damage,
							including but not limited to loss or damage to property or
							for loss of profit, business, revenue, goodwill or
							anticipated savings pursuant to the Golden Week or Contest.
							In no event will the measure of damages include, nor will
							the Relevant Parties be liable for, any amounts for
							indirect, incidental, consequential, or punitive damages of
							any party, including third parties; or for damages
							attributable to the Participant(s); or circumstances beyond
							the Relevant Parties including the Producer's or LSPL's
							reasonable control.
						</li>
					</ol>
					<ol>
						<li>
							The Golden Week, the Contest, the App and website are
							provided on an "as-is" basis without any warranties of any
							kind. To the fullest extent permitted by applicable law,
							LSPL and the Producer, disclaim all warranties, express or
							implied, including, but not limited to, implied warranties
							of merchantability, fitness for a particular purpose and
							non-infringement in respect of the Golden Week, the
							Contest, App and website. Without limiting the foregoing,
							LSPL and the Producer specifically disclaim any warranty
							(a) that the App or Web Page will be uninterrupted or
							error-free, (b) that defects will be corrected, (c) that
							there are no viruses or other harmful components that exist
							on the App and website (d) regarding the security of
							information submitted, and (e) regarding correctness,
							accuracy, or reliability. If Participant's use of the App
							or website, online entry form results in the need for
							servicing or replacement of Participant(s) or another's
							equipment or data, LSPL and/or the Producer are not
							responsible for those costs.
						</li>
					</ol>
					<ol>
						<li>
							The Winner(s) and/or the Participant(s) of the Golden Week
							or the Contest agrees that he/she shall hold harmless
							CMEPL, LSPL, its employees, officers, sub-contractors, its
							affiliates or any other person in connection with the prize
							won by him/her and/or in relation to the Golden Week or the
							Contest and/or Show including but not limited to the
							procedure in the Golden Week or the Contest, any third
							party claims including but not limited to any claims of
							infringement of any third party rights and shall also not
							file in person/ through any family member and/or third
							party any applications, criminal and/or civil proceedings
							in any courts or forum in India against the sponsor and/or
							CMEPL/LSPL to claim any damages or reliefs.
						</li>
					</ol>
					<ol>
						<li>
							LSPL and/or the Producer shall not be responsible for:
						</li>
					</ol>
					<p>
						i. Any delivery, failures relating to the registration or
						submission of answers;
					</p>
					<p>ii. LSPL not receiving or rejecting any data;</p>
					<p>
						iii. Any lost, late or misdirected computer transmission or
						network, electronic failures of any kind or any failure to
						receive entries owing to transmission failures or due to any
						technical reasons and
					</p>
					<p>
						iv. Other conditions/situations or failures beyond its
						control.
					</p>
					<ol>
						<li>
							LSPL and/or the Producer and any of its respective
							affiliates will not be liable for any loss of earnings,
							employment or otherwise caused to the Participant(s) and
							arising as a result of his/her participation in the Golden
							Week or Contest. LSPL and/or the Producer and its
							respective sub-contractors cannot and shall not be held
							accountable/liable for any disruptions / stoppages /
							interruptions or cancellation of the Golden Week or the
							Contest or the Show, on account of any factors beyond their
							control.
						</li>
					</ol>
					<ol>
						<li>
							The Participant(s) and/or any party that accesses the App,
							agrees that neither LSPL nor CMEPL nor any third party
							content or service providers involved in the Golden Week or
							the Contest will be liable to Participant(s) for any loss
							or damages, either actual or consequential, arising out of
							or relating to these Rules, Participant's use or inability
							to use the App, or to Participant's reliance upon
							information obtained from or through the App or website, or
							use or misuse of any prize. In particular, neither LSPL nor
							CMEPL nor its third party or service providers will have
							liability for any consequential, indirect, punitive,
							special or incidental damages, whether foreseeable or
							unforeseeable (including, but not limited to, claims for
							defamation, errors, loss of data, or interruption in
							availability of data), arising out of or relating to the
							awards, terms of use, Participant's use or inability to use
							the App, or to Participant's reliance upon information
							obtained from or through the App or website, participation
							in the Golden Week or the Contest or use or misuse of any
							prize, whether based in contract, tort, statutory or
							otherwise.
						</li>
					</ol>
					<ol>
						<li>
							The Participant(s) or the Winner(s) or his / her legal
							heirs will have no other rights or claims against LSPL
							and/or CMEPL.
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							<strong /> <strong>General Terms and Conditions</strong>
						</li>
					</ol>
					<p>
						<strong /> <br />
					</p>
					<ol>
						<li>
							The participation in the Golden Week or Contest shall be
							considered to be acceptance of these Rules &amp;
							Regulations.
						</li>
						<li>
							The Participant hereby represents that he/she is not under
							any exclusive contracts with any other third party/ agency
							or is not under any kind of disqualification under law to
							enter into an agreement with LSPL or Producer or its
							affiliates, as the case may be.
						</li>
						<li>
							The Participant shall undertake, warrant and guarantee to
							LSPL and Producer that the Participant has the full legal
							capacity to participate in the Golden Week or Contest in
							accordance with these Rules &amp; Regulations.
						</li>
						<li>
							Any requirement by LSPL or Producer for the Participant to
							link his/her social media accounts hereunder, shall not be
							deemed to an endorsement of any of such social media
							platform/accounts and the information accessed by LSPL or
							Producer from such social media accounts shall at all times
							be subject to the terms and conditions of such social media
							website.
						</li>
						<li>
							The Participant acknowledges that he/she has voluntarily
							chosen to participate in the Golden Week or the Contest at
							his / her free-will and is willing to bear all risk, costs
							&amp; consequences arising from such participation in the
							Golden Week or the Contest.
						</li>
						<li>
							In the event of any fault, misunderstanding or dispute
							concerning any part of the Golden Week or the Contest,
							and/or the operation of the telephone system, the selection
							of Winner at any stage, or the validity of any question or
							answer options, the decision of the Producer shall be final
							and binding on all Participant(s) and other persons. LSPL
							and CMEPL are empowered to take a decision on any case or
							instances not covered by the present Rules &amp;
							Regulations.
						</li>
						<li>
							LSPL and CMEPL reserve the right to amend (add, delete or
							modify) the Rules &amp; Regulations prospectively or
							retrospectively, at its discretion and without prior
							notice, in order to improve the Golden Week or the Contest
							or remedy any issues that occur. The Participants are
							advised to regularly check these Terms and conditions.
						</li>
						<li>
							LSPL and CMEPL have the right at any time to terminate the
							Golden Week or the Contest by giving notice to the public
							and also LSPL and/or CMEPL, is not obligated in any manner
							whatsoever to compensate any person or persons who have
							participated in the Golden Week or the Contest. In such an
							event, the prizes declared till date shall be paid by
							Producer and future prizes will be suspended.
						</li>
						<li>
							Registration or participation in the Golden Week or Contest
							does not guarantee a prize or award.
						</li>
						<li>
							If the operation of the Golden Week or Contest; the
							recording or broadcast of any/all of the Show is prevented
							by an event of force majeure or otherwise, LSPL and/or
							CMEPL may cancel all or any part of the Golden Week or
							Contest or take such other decision as it deems fit.
						</li>
						<li>
							In case the Winner(s) is found to be in violation of any
							and all rules/process of the Golden Week or Contest, LSPL
							and/or CMEPL reserve the right to initiate legal
							proceedings against such person(s) including but not
							limited to having the concerned Winner to refund the prize
							money (if any) together with penalty interest as deemed fit
							by LSPL and/or CMEPL. If at any time, including after
							disbursement of prize, any information submitted by the
							Participant(s) is found to be incorrect, false, or
							otherwise misrepresented or misleading, the
							Participant(s)/Winner(s) shall be liable to refund all
							amounts received from the Producer and Producer is liable
							to reclaim the prizes from the Participant(s). LSPL shall
							have no liability in respect of the prizes.
						</li>
						<li>
							If any provision of these Rules &amp; Regulations is held
							by any court or other competent authority to be void or
							unenforceable in whole or part, the other provisions of
							these Rules &amp; Regulations and the remainder of the
							affected provisions shall continue to be valid.
						</li>
						<li>
							These Rules &amp; Regulations and the Golden Week or
							Contest shall be governed by and construed in accordance
							with the laws of India and the Participants(s) submit
							irrevocably to the jurisdiction of the Courts in Mumbai.
						</li>
						<li>
							LSPL and CMEPL are empowered to take a decision on any case
							not covered by the present Terms and conditions.
						</li>
						<li>
							The Participant understands that LSPL is not responsible
							for the winner selection process, framing of the question,
							verification of the answers, and prizes.
						</li>
						<li>
							Once the Contest Winners are selected as per the above
							Rules &amp; Regulations, he/she will be governed by the
							terms and conditions set out in Annexure 1 below.
						</li>
					</ol>
					<p>
						These Terms and conditions have been originally written in
						English. In case of any conflict in the interpretation of the
						clauses between any other language and English rules and
						regulation, the interpretation of the English terms and
						conditions shall prevail.
					</p>
					<p>
						<strong>
							Annexure 1: RULES &amp; REGULATIONS GOVERNING PARTICIPATION
							IN ‘LENSKART GOLDEN WEEK' SPECIAL EPISODES
						</strong>
					</p>
					<ol>
						<li>
							<strong>CONTEST DESCRIPTION:</strong>
						</li>
					</ol>
					<p>
						The "Lenkart Golden Week" is a special event organized by
						CMEPL for the Eligible Participant(s) (as defined herein
						below) who are selected from the Contest for the further
						audition processes to participate in the Kon Honaar Crorepati
						Show in accordance to the terms and conditions detailed below.
					</p>
					<ol>
						<li>
							<strong>DEFINITIONS</strong>:
						</li>
					</ol>
					<p>
						1. <strong>"Online Auditions":</strong> means the online
						auditions to be held by CMEPL on the dates as informed to the
						selected Eligible Participant(s).
					</p>
					<ol>
						<li>
							<strong>"Participant(s)":</strong> Any individual who has
							attempted at least one question in the Contest who (i) is
							above eighteen (18) years of age as on June 05, 2023; (ii)
							is a citizen of India and is residing in India (iii) is of
							sound mind and health (iv) has successfully filled the
							registration form on or before June 11, 2023and (v)
							participates in the Contest in accordance with the Terms
							and Conditions. For avoidance of doubt, employees of
							Lenskart Solutions Private Limited, CMEPL, of the
							advertising agency which has been appointed from time to
							time, and also employees of the sponsors, and members of
							their immediate family; persons other than Indian
							nationals, or Indian nationals living out of India, or
							those who do not qualify under the definition of resident
							of India as per the Income Tax Act, 1961 or those not
							conversant in spoken Marathi, are ineligible to enter the
							Show.
						</li>
						<li>
							" <strong>Auditionee(s)":</strong> The Eligible
							Participant(s) who are selected for participation in the
							auditions.
						</li>
						<li>
							<strong>"Back-up Participant(s)":</strong> The
							Auditionee(s) selected to participate in the Fastest Finger
							First round of the Show, only in case any selected
							Winner(s) does not appear for the shoot at the Studio, for
							any reason.
						</li>
						<li>
							<strong>"Producer" or "CMEPL"</strong>means Culver Max
							Entertainment Private Limited
						</li>
						<li>
							<strong>"Show"</strong>means the television series titled
							"Kon Honaar Crorepati – Season 04" ("KHC") produced by
							Culver Max Entertainment Private Limited and telecasted on
							its channel Sony Marathi
						</li>
						<li>
							"<strong>Contest</strong>" means the general knowledge
							based online quiz contest organized by the Producer during
							the Show, which will be played on the Lenskart App by the
							Participant in accordance with the Rules &amp; Regulations
							during the period mentioned in point D (1) (a) above, as an
							eligibility criterion to participate in the "Lenskart
							Golden Week";
						</li>
						<li>
							"<strong>Lenskart Golden Week/Golden Week</strong>" means
							the week during which the Contest Winners being the users
							of Lenskart App, will be exclusively eligible to
							participate in the Show.
						</li>
						<li>
							"<strong>Contest Winner(s)/Winner(s)</strong>" shall mean
							such Auditionee who get selected for the Fastest Finger
							First as may be determined by the Producer in terms of the
							Rules &amp; Regulations.
						</li>
						<li>
							<strong />"<strong>Company" or "LSPL</strong>" or "Lenskart
							Solutions" means Lensart Solutions Private Limited owning
							and operating Lenskart App;
						</li>
						<li>
							<strong>"Contestant(s)":</strong> The Eligible
							Participant(s), Auditionee(s), Back-up Eligible
							Participant(s), Hot Seat Contestant(s) all collectively or
							individually referred to as "Contestant(s)".
						</li>
					</ol>
					<p>
						<strong>
							<em>
								Any Contestant who has been shortlisted for the online
								audition rounds of the current season; or made it once
								to the Fastest Finger First of the current season of the
								Show or to the hot seat of any of the previous seasons
								of the Show, he/she will not be eligible to participate
								in this segment of the current season of the Show. The
								same is subject to change as per the Producer's
								discretion.
							</em>
						</strong>
					</p>
					<ol>
						<li>
							<strong>"Episode"</strong> means an episode of the Show.
						</li>
						<li>
							<strong>"Fastest-Finger First/FFF"</strong>means that part
							of the Show where three questions are asked consecutively
							to the selected on-show Participant(s), who in turn shall
							answer the same. The first on-show Participant to correctly
							answer all the three questions in the least time shall be
							entitled to proceed to the Hot Seat as the Hot Seat
							Contestant;
						</li>
						<li>
							<strong>"Hot Seat Contestant(s)"</strong>means the
							Winner(s) of the Fastest Finger First round and who
							occupies the Hot Seat before the host of the Show to
							participate further in the Show.
						</li>
						<li>
							<strong>"Lenskart App" or "App"</strong> means the platform
							accessible as a mobile application, owned and operated by
							the Company where the Contest will be hosted.
						</li>
						<li>
							<strong>"Terms and Conditions"</strong> means these terms
							and conditions governing the Golden Week and Contest, as
							stated herein in entirety and as may be amended by the
							Company <strong>and/or the Producer</strong>
							from time to time.
						</li>
						<li>
							<strong>"Schedule":</strong>An Episode or a set of Episodes
							to be recorded and/or recording dates as pre-determined by
							the Producer.
						</li>
						<li>
							<strong>"Studio":</strong> means the Studio at "Film City,
							Goregaon (East), Mumbai" or any other studio as decided by
							the Producer where the shoot for the Show / part of the
							Show / promos of the Show takes place.
						</li>
						<li>
							<strong>"Winner":</strong>The Hot Seat Contestant(s) who
							correctly answers all questions posed by the Host in the
							Show.
						</li>
					</ol>
					<p>
						<strong>PROCEDURE TO PARTICIPATE IN THE SHOW:</strong>
					</p>
					<ol>
						<li>
							From among the Participants who have participated in the
							Contest during the period commencing from June 05, 2023 to
							June 11, 2023, Participants will be considered on
							pre-defined reservation criteria as mentioned hereinbelow,
							and approximately 150 Participants (among the Participants
							who have answered at least one question correctly) (
							<strong>"Eligible Participants"</strong>) will be selected
							to participate in the Audition as Auditionees. Once a
							mobile number is chosen and confirmed for Audition, it
							would not be chosen the second time.
						</li>
					</ol>
					<ol>
						<li>
							Additionally, any Participant who has already appeared for
							Personal Interview in the previous rounds of Kon Honaar
							Crorepati or the PAG Special round of Season will not be
							eligible to be shortlisted.
						</li>
					</ol>
					<ol>
						<li>
							Around 150 selected Participants will be contacted to
							attend the auditions as Auditionees. The top 150 selected
							Eligible Participants will be selected basis the correct
							answer provided and using the pre-defined selection
							criteria on reasonable endeavors basis which is as follows:
						</li>
					</ol>
					<p>
						However, in case exact top 150 Participants are not available
						on account of scores being same for more than 1 Participant,
						balance Participants will be selected randomly basis the above
						grid.
					</p>
					<ol>
						<li>
							In the event, there are less than the required number of
							Auditionees for a particular cell in the reservation grid
							above, then the same will be filled-up from the remaining
							Eligible Participants as maybe required by the Producer.
						</li>
					</ol>
					<ol>
						<li>
							Any Participant who has made it once to the Fastest Finger
							First of the current season of the Show or to the hot seat
							of any of the previous seasons of the Show, he/she will not
							be eligible to participate in this segment of the current
							season of the Show.
						</li>
					</ol>
					<ol>
						<li>
							A manual callout through a Call Centre Executive (CCE)
							callout will be made to notify such selected Participants
							for Auditions (Refer Annexure 1) by telephone and will
							confirm their details (age, gender and email id) before
							proceeding further. If the details provided by the selected
							Participants on this call do not match the existing details
							provided by them, then only one further opportunity will be
							provided to such selected Participants, after which the
							call will be terminated.
						</li>
					</ol>
					<ol>
						<li>
							The Producer shall not be held liable for telephone system
							difficulties, downtime of systems, back-up of data,
							telephone system capacity and other technical impediments
							during the registration process.
						</li>
					</ol>
					<ol>
						<li>
							The Producer shall not be responsible and/or liable in any
							manner whatsoever in case the Auditionee(s) is unable to
							participate in the audition process due to failure in
							delivery of the confirmatory message/ call.
						</li>
					</ol>
					<ol>
						<li>
							The Auditionees will have to be present on the allotted
							Online Audition date and time.
						</li>
					</ol>
					<ol>
						<li>
							Subject to completion of formalities as prescribed by the
							Producer, the Auditionees will have to go through the
							Online Audition which comprises of two rounds viz. general
							knowledge test and personal interview. If the Auditionees
							fail to complete both the general knowledge test and
							personal interview, then he/she shall be disqualified from
							further participation.
						</li>
					</ol>
					<p>(i) Personal Interview</p>
					<ol>
						<li>
							All Auditionees will be required to attend the personal
							interviews as per the designated date and time informed by
							the IVR on the call. All the selected auditionees will
							first have to appear for a general knowledge test which
							will comprise of 10 (ten) general knowledge-based questions
							post which they will have to undergo a personal interview.
						</li>
						<li>
							The Online Auditions will be taped for future reference by
							the Producer.
						</li>
						<li>
							In the event of any unforeseen loss of recordings, Producer
							at its own discretion may request Auditionees to appear for
							a repeat Online Audition session.
						</li>
						<li>
							The Producer reserve the right to increase / decrease /
							alter the number of Auditionees or conduct the audition
							slot wise.
						</li>
					</ol>
					<p>
						The Auditionees will have to submit the scanned copies of the
						following documents along with the completed contestant form
						through email at
						<a href="mailto:kbcmarathi@setindia.com">
							kbcmarathi@setindia.com
						</a>
						prior to the online video interview:
					</p>
					<p>1) For valid name proof (any one of the following):</p>
					<p>1. PAN Card along with Birth certificate</p>
					<p>2. Passport</p>
					<p>3. Voter ID or</p>
					<p>4. Driver's License</p>
					<p>5. UID / Aadhar card</p>
					<p>2) For Valid address proof (any one of the following):</p>
					<p>1. Landline Phone / Electricity Bill</p>
					<p>2. Passport</p>
					<p>3. Voter ID</p>
					<p>4. Driver's License or</p>
					<p>5. Ration card</p>
					<p>6. UID / Aadhar card</p>
					<p>
						(Submission of the aforesaid documents/photos of Video A
						Friend Candidates does not imply that the Auditionee has been
						selected for further participation.)
					</p>
					<p>
						The decision of the Producer in connection with the Audition
						including but not limited to short listing the Auditionees
						will be final &amp; binding and is non-contestable. In case of
						any dispute or difference in respect of this Audition, the
						decision of the Producer shall be final and binding on all
						concerned.
					</p>
					<p>
						The Producer reserves the right to use some of the first (1st)
						round Auditionees as they deem fit for the second (2nd) or any
						subsequent rounds of auditions. The dates for any subsequent
						rounds of auditions will be subsequently informed to the
						relevant shortlisted Auditionees.
					</p>
					<ol>
						<li>
							It is necessary for the Auditionee to have good internet
							connectivity and a smart phone or similar device throughout
							the audition rounds to be eligible for further processing.
							No disputes will be entertained arising out of issues of
							internet connectivity loss or non-availability of
							smartphone or similar device.
						</li>
						<li>
							The personal interviews may be recorded by the Producer for
							the selection process and for future reference. In the
							event of any unforeseen loss of recordings, the Producer
							may, at its own discretion, request Auditionees to appear
							for a repeat personal interview session. The Producer
							reserve the right to increase / decrease / alter the number
							of Auditionees at any point.
						</li>
						<li>
							A three-member jury i.e. including an independent member
							("Judges") will select the final set of participants on the
							basis of the personal interview of the Auditionees. The
							Judges will make two lists of selected Auditionees i.e. the
							Participants that will be selected for the Fastest Finger
							First round who will be the Winners of the Contest and the
							other list of Participants will be used as Back-Up
							Participant(s) for replacement purposes if required by the
							Producer.
						</li>
						<li>
							The Producer may require the Winners and the Backup
							Participants, as may be required, to sign an undertaking or
							declaration any other similar documents prior to them
							attending the shoot, with regard to their participation.
							The Winners and/or the Backup Participants, as the case may
							be, hereby agrees to sign all such documents that may be
							required by the Producer and any refusal by the Winners
							and/or the Backup Participants, as the case may be, to sign
							such documents shall give the Producer the right to
							disqualify such Winners and/or the Backup Participants, as
							the case may be,.
						</li>
						<li>
							The decision of the Producer in connection with the Online
							Audition, including but not limited to short listing, the
							Auditionees will be final &amp; binding and is
							non-contestable. In case of any dispute or difference in
							respect of this audition, the decision of the Producer
							shall be final and binding on all concerned.
						</li>
					</ol>
					<ol>
						<li>
							Two lists of Participants will be selected for the Fastest
							Finger First round, out of which one list of Participants
							will be termed as "Winner List" and the other lit will be
							of Back-Up Participant(s) used for replacement of Winners.
						</li>
					</ol>
					<p>
						Also, 1 Auditionee will be shortlisted from Mumbai (based on
						performance evaluation score) as "stand-by" in order to
						replace any confirmed shortlisted Auditionee who is a
						"no-show" on the day of the shoot.
					</p>
					<ol>
						<li>
							Based on Producer's requirement and creative discretion,
							the final selection of Contestants for Fastest Finger First
							of the Show will be made from amongst the shortlisted pool
							of Auditionees.
						</li>
					</ol>
					<ol>
						<li>
							The representatives of the Producer ("Representatives")
							will notify the selected Auditionees of their selection for
							the Fastest Finger First round and ask for confirmation of
							their details (name, gender, date of birth and address),
							after which the Representatives will inform the selected
							Auditionees of the shoot date and documentation
							requirements, based on finalized shooting schedules. The
							Auditionee is requested to carry a valid English/Hindi
							photo Identity proof and 3 passport size color photographs
							of himself/herself to the Studio for the shoot. In case of
							non-availability of Auditionees or of his/her supporting
							documentation, further participation will not be permitted.
						</li>
					</ol>
					<ol>
						<li>
							For the Shoot, the Producer may cluster the shortlisted
							Auditionee based on creative requirements of the Show. No
							questions / queries will be entertained based on the same.
							The Producer reserves the right to alter or modify the
							cluster without providing any reasons / justifications for
							the same to any person or Contestant(s).
						</li>
					</ol>
					<ol>
						<li>
							Upon confirmation by the selected Winner of the Golden Week
							of his/her availability for the Fastest Finger First round,
							he/she shall be scheduled for the said round.
						</li>
					</ol>
					<ol>
						<li>
							The Winner will be permitted to bring along one companion
							for the shoot of the Episode. The Winner(s) and his/her
							respective companion will travel at their own risk.
						</li>
					</ol>
					<p>
						The Producer shall be responsible for the travel (shortest
						route possible) and hotel stay arrangements of the Winner(s)
						and one companion who have confirmed attendance with the
						Producer. The travel and stay arrangements will be made as per
						the Producer's discretion and any request in this regard by
						the Winners shall not be entertained. However, in case of
						Winner(s) residing in Mumbai, the Producer shall not be
						responsible for making any accommodation arrangements.
					</p>
					<ol>
						<li>
							The Winner(s) who have been selected for the Golden Week
							episode(s) to play Fastest Finger First round shall be
							eligible to play for that week's Golden Week episodes only.
							However, in case of any special episodes or in case of
							cancellation of a particular episode for that week, the
							Winner(s) will not be eligible to play for such days as
							decided by the Producer at their sole discretion.
						</li>
					</ol>
					<ol>
						<li>
							All Participant(s) agree to conform to the terms and
							conditions stated herein along with any terms and
							conditions which may govern the Show.
						</li>
					</ol>
					<ol>
						<li>
							The Terms and Conditions have been originally written in
							English. In case of any conflict in the interpretation of
							the clauses between any other languageand English rules and
							regulation, the interpretation of the English terms and
							conditions shall prevail.
						</li>
					</ol>
					<ol>
						<li>
							Contestant(s) will not be confirmed as Auditionees for the
							Show if they are suffering from any Covid19 symptoms or any
							kind of ill health, medical problems (viz.: heart ailment,
							blood pressure ailment, final stages of pregnancy, etc.).
							It is the responsibility of the Contestant(s) to be
							medically fit for participation. Nevertheless, the final
							decision regarding their participation in the Studio part
							of the Show rests entirely with the Producer. If the
							Auditionee suffers from any medical condition or is
							diagnosed with any medical conditions during the shoot of
							the Show, such that the Auditionee will be unable to shoot
							of the Show any further or his/her presence on the sets
							might put the others on the sets at risk of contracting the
							same medical conditions/issues, then the Producer may
							choose to cancel such participation, at whatever stage the
							same might be. Should the Auditionee not be completely fit
							to travel, it is hereby advised that they inform the
							Producer of the same. The Producer may advice such
							Auditionee not to travel and the Auditionee may stand
							eliminated/disqualified at the discretion of the Producer.
						</li>
					</ol>
					<ol>
						<li>
							If the Producer has reasons to believe that the Auditionee
							shows any symptoms of having contracted COVID -19 or any
							other communicable infections/diseases, then the Producer
							shall have, in its sole discretion, the right to cancel
							their participation, at any given stage and the Auditionee
							hereby agrees not to make any claims in this regard. The
							Producer shall at no time be responsible for any medical
							expenses of the Auditionee and/or their companions, either
							during or after the shoot. The Auditionee hereby undertakes
							to keep the Producer promptly inform in the event he/she is
							feeling unwell or has any symptoms of having contracted
							COVID-19 virus. Any delay or failure on part of the
							Auditionee to inform the Producer of his/her symptoms can
							lead to disqualification.
						</li>
					</ol>
					<ol>
						<li>
							The Contestant hereby undertakes to adhere to all health
							and safety guidelines issued by the Producer. The
							Contestant shall ensure that the Contestant follows and
							abides by all the instructions given by the Producer with
							respect to the shoot of the Show including but not limited
							to all instructions issued by the Producer or any
							production house designated by the Producer with respect to
							the curbing the spread of the COVID -19 virus. The Producer
							reserves the right to terminate the participation of any
							Contestant at any stage in the event the Contestant fails
							to follow any instructions of the Producer with respect to
							the Show.
						</li>
					</ol>
					<ol>
						<li>
							The Producer may require the Winners and the Backup
							Participants to sign an undertaking or declaration any
							other similar documents prior to them attending the shoot,
							with regard to their participation. The Winners and the
							Backup Participants hereby agrees to sign all such
							documents that may be required by the Producer and any
							refusal by the Winners and or the Backup Participants to
							sign such documents shall give the Producer the right to
							disqualify such Winners and/or the Backup Participants as
							the case may be.
						</li>
					</ol>
					<ol>
						<li>
							The Winners and/or the Backup Participants as the case may
							be hereby undertakes that in the event, he/she is unable to
							reach at the designated time slot/date for shoot or is
							unable to participate for the Fastest Finger First round of
							the Show on the given date due to any reasons, including
							any Central or State Government issued guidelines or
							regulations, any disruption in travel etc, the Producer
							shall not be liable to conduct the audition or the
							reschedule the shoot for such Auditionee and they may stand
							eliminated/disqualified at the discretion of the Producer.
						</li>
					</ol>
					<ol>
						<li>
							The Contestant shall be responsible for compliance with
							Covid19 related guidelines issued by the Central/State
							Government or any concerned authority for himself/herself
							and/or their companions. The Contestant and/or their
							companions are advised to always abide by the advisories
							issued by the Government with respect to social distancing
							and wearing masks for their own safety and for the safety
							of the other around them. It is advisable that should the
							facility be easily available in your hometown, you take a
							COVID test prior to travelling for auditions.
						</li>
					</ol>
					<ol>
						<li>
							The Contestant acknowledges that no insurance is required
							for the purpose of participation on the Show. The
							Contestant acknowledges that should the Contestant and/or
							their companion fall ill during the course of travel or
							on/before/after their arrival in Mumbai for the shoot, or
							during or after the shoot, the Producer shall not be
							responsible for the same. It is hereby clarified that the
							Producer shall not be bearing any hospital or medical
							expenses of the Contestant and/or their companion.
						</li>
					</ol>
					<ol>
						<li>
							The Contestant and/or their companion shall not hold the
							Producer responsible, at any time and in any manner
							whatsoever, for any reason whatsoever regarding the
							process, policy or any protocols to be followed during the
							audition process and/or the shoot. The decision of the
							Producer shall be final in all regard with respect to any
							aspect of the Show.
						</li>
					</ol>
					<ol>
						<li>
							The Winners and/or the Backup Participants, as the case may
							be and/or their companion agree that by choosing to travel
							to Mumbai and participating in the Show, they are doing so
							at their own risk, and agree to release the Producer, to
							the maximum extent allowed by law, from any liability,
							direct or indirect, connected to or resulting from any
							Covid19 connected illness that may be suffered by the
							Winners and/or the Backup Participants as the case may be,
							and/or their companion.
						</li>
					</ol>
					<ol>
						<li>
							The Producer shall ensure that personal information
							collected hereunder shall not be share the information so
							collected with any party, save and except for the purpose
							of the Show. The Participant(s) hereby consent to the
							collection, storage, use, disclosure, transfer, of
							sensitive personal information which may be collected by
							the Producer for the purposes of this Audition and/or Show.
							The Participant(s) hereby agree and acknowledge that the
							collection, storage, use, disclosure, transfer, of the
							sensitive personal information by the Producer is for a
							lawful purpose and is necessary for facilitating your
							participation in the Audition and/or Show. The
							Participant's by providing the aforesaid personal
							information and/or sensitive personal information hereby
							agree that the Producer shall have the right to share the
							information so collected with such other third party
							including LSPL and as required for the purpose of the Show
							and the Participant(s) hereby agreed that they shall not
							file any claim against the Producer for sharing for such
							personal information. Please refer to Producer's Privacy
							Policy
							<a href="http://www.setindia.com/privacy.php">
								http://www.setindia.com/privacy.php
							</a>
							that governs the use of your personal information.
							Participant(s) choosing to participate in the Show agree
							and acknowledge the Terms and Conditions, Privacy Policy
							and Terms of Use as put up on the website
							<a href="http://www.setindia.com">www.setindia.com</a>
							in addition to the conditions set out in these Terms and
							conditions which shall govern the Show.
						</li>
					</ol>
					<ol>
						<li>
							The Producer shall deal with any data/personal information
							including sensitive personal information, if any, that it
							receives from Participant(s) or otherwise collects, holds,
							uses and processes in the following manner: a) Producer may
							also disclose data/ personal information including
							sensitive personal information, if any, to governmental
							agencies and regulators (e.g., tax authorities), social
							organizations (e.g., the social security administration),
							human resources benefits providers (e.g., health insurers),
							external advisors (e.g., lawyers, accountants, and
							auditors), courts and other tribunals, and government
							authorities, to the extent required or permitted by
							applicable legal obligations upon prior written approval
							from the Producer. b) The level of data protection using
							technical, managerial, operational and physical security
							control measures by the Producer shall be such as to be in
							compliance with all applicable laws. c) The term
							"data/personal information" including sensitive personal
							information, if any, shall mean and include the name and
							contact information (home address, telephone and fax
							numbers and email address), valid identity proof such as
							passport number, driver's license number, permanent account
							numbers or other details pertaining to the identity of the
							Participant(s). The photos, images and Online Audition
							videos uploaded by the Participant(s) may be retained by
							the Producer and LSPL till the winners are declared and the
							promotions with respect to the winners is completed for the
							Show.
						</li>
					</ol>
					<ol>
						<li>
							In exercise of the powers conferred by applicable laws, the
							Producer shall treat the personal information including
							sensitive personal information as confidential and such
							information has to be now dealt with as per the provisions
							specified in the applicable laws.
						</li>
					</ol>
					<ol>
						<li>
							For the purposes of the Show, the Producer may contract
							with the service providers to perform functions or services
							on its behalf. Such service provider may have limited
							access to the Participant(s) personal information needed to
							perform their functions but shall be restricted from using
							such personal information for purposes other than providing
							services to the Producer solely in connection with the
							Show. The Producer y shall ensure, on reasonable efforts
							basis, that its service providers that have limited access
							to personal information provided by the Participant(s) to
							provide the services or perform their function for the
							Producer are subject to the same level of privacy
							protection as is required by the applicable laws. The
							Participant(s) hereby agreed that they shall not file any
							claim against the Producer for sharing for such personal
							information.
						</li>
					</ol>
					<ol>
						<li>
							These Rules &amp; Regulations shall be governed by and
							construed in accordance with the laws of India and the
							Participant(s) submit irrevocably to the jurisdiction of
							the Courts in Mumbai
						</li>
					</ol>
					<ol>
						<li>
							The Producer reserves the right to amend (add, delete or
							modify) the Rules &amp; Regulations prospectively or
							retrospectively, at its discretion and without prior
							notice, in order to improve or remedy any issues that
							occur.
						</li>
						<li>
							The Producer has the right at any time to terminate the
							Contest/Show without any prior intimation or notice to the
							public and also the Producer is not obligated in any manner
							whatsoever to compensate any person or persons who have
							participated in the Contest.
						</li>
						<li>
							The Participant understands that LSPL only facilitates
							access to the Contest through the Lenskart App. Once the
							Contest is completed through the Lenskart app, LSPL has no
							liability or responsibility with respect to the conducting
							of the Golden Week including but not limited to auditions,
							FFF, winner selection etc.
						</li>
						<li>
							The Producer is empowered to take a decision on any case
							not covered by the present Terms and conditions.
						</li>
					</ol>
				</div>
			</TNCWrapper>
			<CloseButtonWrapper>
				<CloseButton onClick={() => closeWindowPortal()}>
					Close and Return!
				</CloseButton>
			</CloseButtonWrapper>
		</>
	)
}

export default TnContent
